<template lang="pug">
  .p-30
    .row.align-items-center.flex-sm-row-reverse.mb-3
      .col-sm-auto.ml-auto.mb-3.mb-sm-0.text-center
        el-button(type='primary' @click="dialog = true") Add Team
      .col-sm.max-w-530
        el-input(
          v-model="searchInput"
          prefix-icon="el-icon-search"
          placeholder="Search Team..."
        )
    .card
      .card-body
        el-table(
          :data="filteredItems"
          v-loading="loading"
          @row-click="rowClicked"
          style="width: 100%"
        ).clickable-rows
          el-table-column(label="Team" prop="name" min-width="250")
            .d-flex(slot-scope="props")
              .size-42.rounded-circle.d-flex.mr-3(:style="{ backgroundColor: props.row.color }")
                font-awesome-icon( :icon="['fal', props.row.icon]" size="2x" ).m-auto.text-white
              .my-auto {{ props.row.name }}

          el-table-column(width="46")
            .el-table__expand-icon
              i.el-icon.el-icon-arrow-right

    dialog-add-edit-team(
      v-if="dialog"
      :loading="loading"
      :dialog-visible.sync="dialog"
      :edited-item="editedItem"
      :form-title="formTitle"
      @save-item="saveTeam"
      @delete-item="deleteTeam"
      @close-dialog="closeDialog"
    )
</template>

<script>

import uuid from 'uuid-v4';
import { mapGetters } from 'vuex';

import cleanDeep from 'clean-deep';
import { team as initTeam } from '@/data/init';
import { teams as dummyTeams } from '@/data/static';
import CrudDialogMixin from '@/mixins/crudDialogMixin';
import SubscribeMixin from '@/mixins/subscribeMixin';
import DialogAddEditTeam from './DialogAddEditTeam.vue';

import {
  getTeamRecordsByCompany,
  createTeamRecord,
  updateTeamRecord,
  deleteTeamRecord,
} from '../../models/teams';

export default {
  name: 'Teams',
  components: { DialogAddEditTeam },
  mixins: [CrudDialogMixin, SubscribeMixin],

  data() {
    return {
      searchInput: '',
      teams: dummyTeams,
    };
  },

  computed: {
    ...mapGetters('users', ['me', 'isMeSignedIn', 'scopedCompany', 'isSuperAdmin']),
    filteredItems() {
      return this.getFilteredItems();
    },
    companyId() {
      if (this.scopedCompany) return this.scopedCompany.id;
      return null;
    },
  },
  watch: {
    me(val) {
      if (val) {
        this.init();
      }
    },
  },
  mounted() {
    if (this.companyId) {
      this.init();
      this.initComp();
    } else {
      this.$router.push('/teams');
    }
  },

  methods: {
    init() {
      if (this.companyId) this.initComp();
    },
    initComp() {
      // init team data
      this.editedItem = JSON.parse(JSON.stringify(initTeam));
      this.defaultItem = JSON.parse(JSON.stringify(initTeam));
      this.getTeamList();
      this.subscribeToTeamEvents();
      this.loading = false;
    },

    rowClicked(row) {
      this.editItem(row);
    },

    filterItem(item) {
      return item.toLowerCase().includes(this.searchInput.toLowerCase());
    },

    getFilteredItems() {
      return this.items.filter(
        (item) => this.filterItem(item.name),
      );
    },
    getTeamList() {
      getTeamRecordsByCompany(this.companyId).then((res) => {
        this.items.length = 0;
        res.data.getTeamByCompany.items.forEach((team) => {
          this.items.push(team);
        });
        this.items.sort((a, b) => a.name.localeCompare(b.name));
      });
    },
    subscribeToTeamEvents() {
      this.subscribeAndInvoke(
        [
          'onCreateTeam',
          'onUpdateTeam',
          'onDeleteTeam',
        ],
        this.getTeamList,
      );
    },
    async saveTeam() {
      this.loading = true;
      if (this.editedItem.id) {
        ['createdAt', 'updatedAt', 'companyId'].forEach((attr) => {
          delete this.editedItem[attr];
        });
        this.updateTeam();
      } else {
        this.editedItem.id = uuid();
        this.editedItem.companyId = this.companyId;
        console.log(this.editedItem);
        this.createTeam();
      }
    },

    createTeam() {
      console.log('Create New Team', this.editedItem.companyId);
      createTeamRecord(this.editedItem).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.closeDialog();
        this.loading = false;
      });
    },

    updateTeam() {
      updateTeamRecord(this.editedItem).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.closeDialog();
        this.loading = false;
      });
    },

    deleteTeam() {
      const teamItem = cleanDeep(this.editedItem);
      const { id } = teamItem;
      const that = this;
      this.$msgbox({
        title: 'Message',
        type: 'warning',
        message: 'This will permanently delete the record. Continue?',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = 'Deleting...';
            that.deleteTeamItem(id).then(() => {
              instance.confirmButtonLoading = false;
            }).catch(() => {
              this.notifyMsg('error in deleting company');
            });
            instance.confirmButtonLoading = false;
            this.closeDialog();
            done();
          } else {
            done();
          }
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelled',
        });
      });
    },
    deleteTeamItem(id) {
      return new Promise((resolve, reject) => {
        if (id && id !== '0') {
          // Team delete company user record to
          deleteTeamRecord({ id }).then(() => {
            resolve();
          }).catch((e) => {
            console.log(e);
            reject(new Error(e));
          });
        } else {
          resolve();
        }
      });
    },
  },
};
</script>
